import React from "react";
import { Link } from "react-router-dom";
import Header from "../../Common/Layout/Header"; 
import { useAuth } from "../../Common/Configurations/AuthContext";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import "./HotelWebsiteShowcase.css";
import HotelDmcTabs from "../HotelDmc/HotelDmcTabs";

const HotelWebsiteShowcase = () => {
    const { user } = useAuth();

    // Data for your 4 Hotel websites
    const demos = [
        {
            id: 1,
            title: "Grand Hospitality",
            desc: "Sophisticated Slate Blue & Gold design. Focuses on corporate trust, amenities, and clear reservation flow.",
            path: "/hotel-website1",
            badge: "Professional",
            color: "primary",
            img: "/assets/images/Hotel-Website1.png" 
        },
        {
            id: 3,
            title: "Elite Concierge",
            desc: "Immersive architectural layout with a floating booking widget. High-end Onyx & Champagne Gold palette.",
            path: "/hotel-website3",
            badge: "Architectural",
            color: "dark",
            img: "/assets/images/Hotel-Website3.png" 
        },
        {
            id: 4,
            title: "Vibrant Stay",
            desc: "Fresh Mint & Lemon design featuring Instagram-style story filters and a contemporary discovery feed.",
            path: "/hotel-website4",
            badge: "Contemporary",
            color: "warning",
            img: "/assets/images/Hotel-Website4.png" 
        }
    ];

    return (
        <div id="layout-wrapper" style={{ background: '#f3f4f6', minHeight: '100vh' }}>
            <Header User={user} activeSection="hotel-showcase" />
            
            <div className="main-content" style={{  padding: '20px' }}>
                <div className="page-content">
                    <div className="container-fluid">
                        <div className="p-2">
                {/* <HotelDmcTabs pageName="YOUR_WEBSITE" /> */}
              </div>
                        {/* Header Section */}
                        <div className="row mb-1 text-center">
                            <div className="col-lg-8 mx-auto">
                                <h2 className="hotel-webisteshowcase-title">Hotel Design Gallery</h2>
                                <p className="text-muted">
                                    Preview our premium hospitality templates designed for resorts, luxury hotels, and boutique stays.
                                </p>
                            </div>
                        </div>

                        {/* Cards Grid */}
                        <div className="row justify-content-center">
                            {demos.map((demo) => (
                                <div key={demo.id} className="col-xl-3 col-md-6 mb-4">
                                    <div className="card h-100 border-0 shadow-lg hotel-webisteshowcase-card">
                                        
                                        {/* Image Section */}
                                        <div className="hotel-webisteshowcase-img-wrapper">
                                            <img 
                                                src={demo.img} 
                                                alt={demo.title} 
                                                className="hotel-webisteshowcase-img" 
                                                onError={(e) => { e.target.src = "https://via.placeholder.com/800x600?text=Hotel+Preview+Missing"; }}
                                            />
                                            <div className="hotel-webisteshowcase-overlay">
                                                <Link 
                                                    to={demo.path} 
                                                    target="_blank" 
                                                    rel="noopener noreferrer"
                                                    className="btn btn-light rounded-pill px-4 fw-bold"
                                                >
                                                    <FontAwesomeIcon icon={faExternalLinkAlt} className="me-2" />
                                                    Live Preview
                                                </Link>
                                            </div>
                                            <span className={`badge bg-${demo.color} hotel-webisteshowcase-badge`}>
                                                {demo.badge}
                                            </span>
                                        </div>

                                        {/* Content Section */}
                                        <div className="card-body p-4 text-center d-flex flex-column">
                                            <h5 className="card-title fw-bold mb-2">{demo.title}</h5>
                                            <p className="text-muted small flex-grow-1">{demo.desc}</p>

                                            <Link 
                                                to={demo.path} 
                                                target="_blank" 
                                                rel="noopener noreferrer"
                                                className={`btn btn-soft-${demo.color} w-100 mt-3 fw-bold`}
                                            >
                                                Launch Website
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default HotelWebsiteShowcase;